import type { LandingPageForm } from "@/features/landing/use-landing-page-form";

type LandingAttribution = Pick<
	LandingPageForm,
	| "campaignId"
	| "utmCampaign"
	| "utmSource"
	| "utmMedium"
	| "utmTerm"
	| "utmContent"
	| "adtractionId"
	| "googleClickId"
	| "facebookClickId"
>;

const getParam = (params: URLSearchParams, key: string) =>
	params.get(key) || undefined;

export const getLandingAttribution = (search: string): LandingAttribution => {
	const params = new URLSearchParams(search);
	const utmCampaign = getParam(params, "utm_campaign");

	return {
		campaignId: utmCampaign,
		utmCampaign,
		utmSource: getParam(params, "utm_source"),
		utmMedium: getParam(params, "utm_medium"),
		utmTerm: getParam(params, "utm_term"),
		utmContent: getParam(params, "utm_content"),
		adtractionId: getParam(params, "at_gd"),
		googleClickId:
			getParam(params, "gclid") ?? getParam(params, "googleClickId"),
		facebookClickId:
			getParam(params, "fbclid") ?? getParam(params, "facebookClickId"),
	};
};
